<template>
  <div>
    <CCard style="margin-top: 10px">
      <CCardBody>
        <CInput
          label="First name"
          placeholder="Enter your firstname"
          v-model="firstname"
        />
        <CInput
          label="Last name"
          placeholder="Enter your lastname"
          v-model="lastname"
        />
        <CButton @click="datasave()" color="success" v-if="normalsave"
          >Save</CButton
        >
        <CButton @click="updatesavedata()" color="success" v-if="updatesave"
          >update</CButton
        >
      </CCardBody>
    </CCard>
    <br />
    <CCard>
      <CCardBody>
        <CDataTable
          :items="tableData"
          :fields="fields"
          column-filter
          table-filter
          items-per-page-select
          :items-per-page="10"
          hover
          sorter
          pagination
        >
          <template #Action="{ item, index }">
            <td>
              <CButton
                color="info"
                variant="outline"
                square
                size="sm"
                @click="editdata(item, index)"
              >
                Edit </CButton
              >&nbsp;&nbsp;
              <CButton
                color="danger"
                variant="outline"
                square
                size="sm"
                @click="deleteRoute(item, index)"
              >
                Delete
              </CButton>
            </td>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
const db = firebase.firestore();
export default {
  data() {
    return {
      normalsave: true,
      updatesave: false,
      firstname: "",
      lastname: "",
      getitemID:"",
      tableData: [],
      fields: [
        {
          label: "Firstname",
          key: "firstname",
          sortable: true,
        },
        {
          label: "lastname",
          key: "lastname",
          sortable: true,
        },
        {
          label: "Action",
          key: "Action",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    editdata(item) {
      this.getitemID =item._id;
      this.firstname = item.firstname, this.lastname = item.lastname;
      this.normalsave = false, this.updatesave = true;
    },
    deleteRoute(item) {
      console.log("deleteRoute", item._id);
      this.documentId = item._id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    delete() {
      // console.log("item",item)
      let id = this.documentId;
      let data = { id };
      APIService.testdataDelete(data).then((res) => {
        if (res.status == 200) {
          console.log("datadelete");
          window.location.reload();
        }
      });
    },
    datasave() {
      let firstname = this.firstname;
      let lastname = this.lastname;
      let data = {
        firstname,
        lastname,
      };
      APIService.savetestdata(data).then((res) => {
        if (res.status == 200) {
          this.firstname = "";
          this.lastname = "";
          // this.getdata();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },

       updatesavedata() {
         console.log("getitemID",this.getitemID)
      let id =  this.getitemID;
      let firstname = this.firstname;
      let lastname = this.lastname;
      let value = {
        firstname,
        lastname,
      };
      let data ={value, id }
      APIService.testdataUpdate(data).then((res) => {
        if (res.status == 200) {
          this.firstname = "";
          this.lastname = "";
          // this.getdata();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
      window.location.reload();
    },
    getdata() {
      APIService.gettestdata().then((res) => {
        if (res.status == 200) {
          console.log("resdata", res.data);
          this.tableData = res.data;
        }
      });
    },
  },
  created() {
    this.getdata();
  },
};
</script>

<style >
.swal2-cancel {
  margin: 10px !important;
}
</style>
<style  scoped>
</style>
